import PrototypeConfirmationPopup from './PrototypeConfirmationPopup';

export default PrototypeConfirmationPopup;
